const ANNOUNCEMENT_REMOVE_DELAY_MS = 1000;

const visuallyHiddenStyles = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: '0',
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: '0',
};

/**
 * Announce a message to screen readers by injecting a fresh role="alert"
 * node. Matches the standard sr-only clip pattern used elsewhere in the gradebook.
 */
export function announceToScreenReader(message) {
  if (!message || typeof document === 'undefined') {
    return;
  }

  const node = document.createElement('div');
  node.setAttribute('role', 'alert');
  node.setAttribute('aria-live', 'polite');
  node.setAttribute('aria-atomic', 'true');
  Object.assign(node.style, visuallyHiddenStyles);
  node.textContent = message;

  document.body.appendChild(node);

  window.setTimeout(() => {
    if (node.parentNode) {
      node.parentNode.removeChild(node);
    }
  }, ANNOUNCEMENT_REMOVE_DELAY_MS);
}
